export const convertTime = (totalSeconds) => {
    if (totalSeconds <= 0 || !totalSeconds || isNaN(totalSeconds)) return { hours: 0, minutes: 0, seconds: 0 }
    const hours = Math.floor(totalSeconds / (60 * 60))
    const minutes = Math.floor((totalSeconds % (60 * 60)) / 60)
    const seconds = Math.round(totalSeconds % 60)
    return { hours, minutes, seconds }
  }